var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',[_c('mars-view',{staticClass:"tag-layout",style:({
    padding: _vm.paddingVertical + ' ' + _vm.paddingHorizontal
})},[_vm._l((_vm.options),function(option,optionIndex){return _c('c-filter-tag-layout-item',{key:optionIndex,style:({
        width: 100 / _vm.options.length + '%'
    }),attrs:{"index":optionIndex,"text":option.text,"default-value":option.defaultValue,"type":option.type,"selected-color":_vm.primaryColor,"selected-item-bold":_vm.selectedItemBold,"selected":_vm.selectedIndex === optionIndex || option.selected,"up":_vm.selectedIndex === optionIndex,"direction":option.direction},nativeOn:{"click":function($event){return _vm.handleTagLayoutItemTap({
        option,
        optionIndex
    })}}})}),_vm._t("default")],2),(_vm.borderBottom)?_c('mars-view',{staticClass:"border"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }